import appConfig from '../../config/appConfig';
import * as logMessageTypes from '../../consts/app/logMessageTypes';
import {IS_PARALLEL_FETCH_TOKEN} from '../../consts/app/yapInitialState';
import uamTimeouts from '../../consts/config/uamTimeouts';
import * as yapActionStatusTypes from '../../consts/yap/yapActionStatusTypes';
import {setFetchTokenInProgress} from '../../state/ducks/auth';
import {setSyncLastRequestId, setYapLastRequestId} from '../../state/ducks/yapEncrypted';
import {makeSelecIsFetchTokenInProgress} from '../../state/selectors/auth';
import {
    makeSelectAssetIdByType,
    makeSelectIsHolderByAssetId,
    makeSelectSyncLastRequestId,
    makeSelectYapLastRequestId,
} from '../../state/selectors/yapEncrypted';
import {dispatch, getState} from '../../state/store';
import helpers from '../../utils/helpers';
import backendService from '../app/backendService';
import gamClientService from '../gam/gamClientService';
import consumerAggregatedSettingsService from '../icc/consumerAggregatedSettingsService';
import log from '../logger/log';
import uamClientService from '../uam/uamClientService';

const isDataCollectionEnabled = () =>
    appConfig.getIsDataCollectionEnabled() && consumerAggregatedSettingsService.isEnabledDataCollection();

const proceedAction = ({status, requestId, assetId, isSync = false}) => {
    const isPending = status === yapActionStatusTypes.PENDING;

    if (isPending) return;

    const state = getState();
    const isHolder = makeSelectIsHolderByAssetId(assetId)(state);
    const holderRequestId = makeSelectYapLastRequestId(true)(state);
    const deviceRequestId = makeSelectYapLastRequestId()(state);
    const curRequestId = isHolder ? holderRequestId : deviceRequestId;
    const lastRequestId = isSync ? makeSelectSyncLastRequestId(isHolder)(state) : curRequestId;

    if (requestId !== lastRequestId) {
        log.info(`WebSocketService: answer for requestId ${requestId} is ignored. Waiting for ${lastRequestId}`);
        return false;
    }

    const isFailed = status === yapActionStatusTypes.FAILED;
    const isSuccess = status === yapActionStatusTypes.SUCCESS;

    if (!isFailed && !isSuccess) return;

    if (isSync) {
        dispatch(setSyncLastRequestId(null, isHolder));
    } else {
        dispatch(setYapLastRequestId(null, isHolder));
    }

    return isSuccess ? yapActionStatusTypes.SUCCESS : yapActionStatusTypes.FAILED;
};

const getSyncAsset = async (isHolder) => {
    let assetId = makeSelectAssetIdByType(isHolder)(getState());

    if (assetId) return assetId;

    await waitUntilFetchTokenFinish(isHolder);

    const isGamBackend = backendService.isGamBackend();
    let isValid;

    if (isGamBackend) {
        isValid = await gamClientService.initGam(isHolder);
    } else {
        isValid = await uamClientService.getAssets({isHolder});
    }
    if (isValid) {
        assetId = makeSelectAssetIdByType(isHolder)(getState());
    }
    if (isValid && assetId) return assetId;
    log.error(
        `yapService: Asset does not exist for registered device isHolder: ${!!isHolder}.`,
        isGamBackend ? logMessageTypes.GAM : logMessageTypes.UAM
    );

    //due fast state change timeout is added
    await helpers.timeout(500);
    return null;
};

const waitUntilFetchTokenFinish = async (isHolder, timer = uamTimeouts.UAM_WAIT_FETCH_TOKEN_TIMEOUT) => {
    if (IS_PARALLEL_FETCH_TOKEN) return;
    const isGamBackend = backendService.isGamBackend();
    const isFetchTokenInProgress = makeSelecIsFetchTokenInProgress()(getState());

    if (!isFetchTokenInProgress) {
        dispatch(setFetchTokenInProgress(true));
        return;
    }

    if (--timer < 0) {
        log.info(
            `yapService: Does not receive token:  ${!!isHolder}.`,
            isGamBackend ? logMessageTypes.GAM : logMessageTypes.UAM
        );
        return;
    }

    await helpers.timeout(1000);
    return waitUntilFetchTokenFinish(timer);
};

export default {
    getSyncAsset,
    isDataCollectionEnabled,
    proceedAction,
    waitUntilFetchTokenFinish,
};
